import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Card, CardBody, Col, Row, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import ThemeContext from '@app/providers/contexts/ThemeContext';
import Page from '@app/components/Page';
import { MdInsertChart, MdAccessTime } from 'react-icons/md';
import Loader from '@app/components/Loader';
import './Reporting.css';

interface ThemeContextType {
  theme: string;
  setTheme: (theme: string) => void;
}

interface ReportOption {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
  isDisabled?: boolean;
  comingSoon?: boolean;
}

const ReportingView: React.FC = () => {
  const { theme } = React.useContext(ThemeContext) as ThemeContextType;
  const [isLoading, setIsLoading] = React.useState(true);
  
  // Report options
  const reportOptions: ReportOption[] = [
    {
      id: 'starlink-usage',
      title: 'Starlink Usage Reports',
      description: 'Generate and view monthly Starlink usage reports for your organization',
      icon: <MdInsertChart size={48} />,
      link: '/reporting/starlink-usage'
    },
    {
      id: 'downtime-saved',
      title: 'Downtime Saved',
      description: 'View reports on the amount of downtime saved by using Starlink as a backup',
      icon: <MdAccessTime size={48} />,
      link: '#',
      isDisabled: true,
      comingSoon: false
    }
  ];

  React.useEffect(() => {
    // Simulate loading to match the application pattern
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Helmet>
        <title>Reporting</title>
      </Helmet>
      {isLoading ? (
        <Loader />
      ) : (
        <Page
          tag="div"
          className={`cr-page px-3 pt-2 ${theme}`}
          title=""
          breadcrumbs={[
            { name: 'Dashboard', active: false, to: '/dashboard' },
            { name: 'Reporting', active: true }
          ]}
        >
          <Row>
            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
              <div className="dashboard-card-wrapper">
                <Row>
                  {reportOptions.map((option) => (
                    <Col lg={4} md={6} sm={12} key={option.id} className="mb-4">
                      {option.isDisabled ? (
                        <Card className="h-100 report-option-card disabled-card">
                          <CardBody className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
                            <div className="mb-3 text-muted">
                              {option.icon}
                            </div>
                            <h4 className="text-muted">{option.title}</h4>
                            <p className="text-muted">{option.description}</p>
                          </CardBody>
                        </Card>
                      ) : (
                        <Link to={option.link} className="text-decoration-none">
                          <Card className="h-100 report-option-card">
                            <CardBody className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
                              <div className="mb-3 text-primary">
                                {option.icon}
                              </div>
                              <h4>{option.title}</h4>
                              <p className="text-muted">{option.description}</p>
                            </CardBody>
                          </Card>
                        </Link>
                      )}
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </Page>
      )}
    </>
  );
};

export default ReportingView; 